import { createSelector } from 'reselect'

import { ComposedListing, ListingsGroup } from '../../types/app-types'

import type { MapState, MapStateType } from './types'

export const mapContent = createSelector(
    (state: MapStateType) => {
        return { data: state.data }
    },
    ({ data }) => data,
)

export const getMapState = createSelector(
    (mapState: MapState) => {
        return { mapState: mapState }
    },
    ({ mapState }) => mapState,
)

// Gets the lowest priced listing of the hovered section
export const lowestPricedListingInSectionSelector = createSelector(
    (composedListings: (ListingsGroup | ComposedListing)[], sectionId: string) => ({ composedListings, sectionId }),
    ({ composedListings, sectionId }) => {
        if (composedListings.length === 0 || !sectionId) {
            return undefined
        } else if (composedListings.length === 1) {
            return composedListings[0]
        }

        return composedListings
            .filter((listing) => listing.sectionId === sectionId)
            .reduce((previousListing, currentListing) => {
                return currentListing.price < previousListing.price ? currentListing : previousListing
            })
    },
)
